import React from 'react';
import PropTypes from 'prop-types';
import { dateToS } from '../../../util/dateUtil';
import { makeStyles } from '@material-ui/core/styles';
import Card from '../../Card/Card.js';
import CardBody from '../../Card/CardBody.js';
import CardHeader from '../../Card/CardHeader.js';
import { IconButton } from '@material-ui/core';
import { btNavyBlueColor, btMediumGrayColor } from '../../../assets/jss/nextjs-material-kit-pro';
import EditIcon from '@material-ui/icons/Edit';
import EmailIcon from '@material-ui/icons/Email';

const useStyles = makeStyles((theme) => ({
  edit: {
    textAlign: 'center',
  },
  card: {
    width: '350px',
    height: '210px',
  },
  cardBody: {
    padding: 10,
  },
  cardHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: 'dotted 1px gray',
    padding: '15px 10px 5px 10px',
    marginLeft: 0,
    marginRight: 0,
    marginTop: -5,
  },
  dataBold: {
    fontWeight: 600,
  },
  boldName: {
    fontWeight: 600,
    fontSize: '1.05rem',
  },
}));

export default function SnackbarContent(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Card className={classes.card} key={props.staff.id}>
        <CardHeader className={classes.cardHeader}>
          <div className={classes.boldName} style={{ color: props.staff.user.is_active ? btNavyBlueColor : btMediumGrayColor }}>
            {props.staff.user.first_name} {props.staff.user.last_name} {props.staff.user.is_active ? '' : '(Inactive)'}
          </div>
          <div className={classes.rowButtonContainer}>
            <IconButton
              className={classes.circleIcon}
              color="primary"
              variant="contained"
              size="small"
              aria-label="Edit"
              onClick={(e) => {
                props.handleEditStaff(props.staff);
              }}
            >
              <EditIcon style={{ fontSize: 'small' }} />
            </IconButton>
            {/* FUTURE */}
            {/* <IconButton
                    className={classes.circleIcon}
                    color="primary"
                    variant="contained"
                    size="small"
                    aria-label="Refresh"
                    onClick={(e) => {
                      console.log('refresh');
                    }}
                  >
                    <ReplayIcon style={{ fontSize: 'small' }} />
                  </IconButton> */}
            {props.staff.user.is_active ? (
              <IconButton
                className={classes.circleIcon}
                size="small"
                color="primary"
                variant="contained"
                aria-label="Email"
                onClick={(e) => {
                  console.log('email');
                }}
              >
                <EmailIcon style={{ fontSize: 'small' }} />
              </IconButton>
            ) : (
              ''
            )}
          </div>
        </CardHeader>
        <CardBody
          className={classes.cardBody}
          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }}
        >
          <div className={classes.dataBold} style={{ color: props.staff.user.is_active ? btNavyBlueColor : btMediumGrayColor }}>
            {props.staff.user.email}
          </div>
          <div className={classes.dataBold} style={{ color: props.staff.user.is_active ? btNavyBlueColor : btMediumGrayColor }}>
            <label style={{ color: props.staff.user.is_active ? btNavyBlueColor : btMediumGrayColor }}>Role</label>{' '}
            {props.staff.user.roles.toString()}
          </div>
          <div className={classes.dataBold} style={{ color: props.staff.user.is_active ? btNavyBlueColor : btMediumGrayColor }}>
            <label style={{ color: props.staff.user.is_active ? btNavyBlueColor : btMediumGrayColor }}>Title</label> {props.staff.position_title}
          </div>
          <div className={classes.dataBold} style={{ color: props.staff.user.is_active ? btNavyBlueColor : btMediumGrayColor }}>
            <label style={{ color: props.staff.user.is_active ? btNavyBlueColor : btMediumGrayColor }}>Last Login</label>{' '}
            {dateToS(props.staff.user.last_login) || 'N/A'}
          </div>
          <div className={classes.dataBold} style={{ color: props.staff.user.is_active ? btNavyBlueColor : btMediumGrayColor }}>
            <label style={{ color: props.staff.user.is_active ? btNavyBlueColor : btMediumGrayColor }}>Last Updated</label>{' '}
            {dateToS(props.staff.user.updated_at)}
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
}

SnackbarContent.propTypes = {
  staff: PropTypes.object.isRequired,
  handleEditStaff: PropTypes.func.isRequired,
};
